import { ScrollReveal, SectionLabel } from "./Reveal";

const steps = [
  { n: "01", title: "Discover", desc: "We talk about what you're trying to achieve." },
  { n: "02", title: "Plan", desc: "We develop the concept, locations and shots." },
  { n: "03", title: "Film", desc: "I come to you and capture the story." },
  { n: "04", title: "Edit", desc: "You receive a polished cinematic film ready to use." },
  { n: "05", title: "Release", desc: "You use the content across your website and social." },
];

export const ProcessSection = () => (
  <section data-testid="process-section" className="py-24 lg:py-32">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <ScrollReveal>
        <SectionLabel index="07" title="The Process" />
        <h2 className="font-display leading-[0.95] text-5xl sm:text-6xl lg:text-7xl">Five steps.</h2>
      </ScrollReveal>

      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-5 gap-px bg-white/10 border border-white/10">
        {steps.map((s, i) => (
          <ScrollReveal key={s.n} delay={i * 0.07} className="h-full">
            <div
              data-testid={`process-step-${s.n}`}
              className="group bg-[#0A0A0A] hover:bg-[#111111] p-8 h-full flex flex-col transition-colors duration-500"
            >
              <span className="font-display text-4xl text-outline group-hover:text-[#F2F0EB] group-hover:[-webkit-text-stroke:0px] transition-all duration-500">{s.n}</span>
              <h3 className="font-display text-xl mt-8">{s.title}</h3>
              <p className="text-sm text-[#8A8A85] leading-relaxed mt-3">{s.desc}</p>
            </div>
          </ScrollReveal>
        ))}
      </div>
    </div>
  </section>
);
